import axios from '../plugins/axios';

export default {
  loadSecureInfoList() {
    const url = process.env.VUE_APP_HIWORKS_SECURE_API + `/alarms`;
    return axios.get(url, { timeout: 3_000 });
  },
};
